<template>
  <div class="alarm-container">
    <div class="status-container">
      <toggle-button
        class="h-100 mr-1"
        :value="alarm.enabled"
        @change="onChangeEventHandler"
        :labels="{
          unchecked: 'выкл',
          checked: 'вкл'
        }"
        :width="65"
      />
      <input class="h-100 " type="text" placeholder="Приветствие при напоминании" v-model="alarm.greeting" />
    </div>
    <div class="time-container">
      <select v-model="zone">
        <option v-for="timezone in timezones" :key="timezone" :value="timezone">{{ timezone ? `(GMT ${timezone}:00)` : "(GMT)" }}</option>
      </select>
      <input
        class="hours"
        type="number"
        min="0"
        max="23"
        maxlength="2"
        v-model="hours"
        ref="hours"
        @focus="$event.target.select()"
        @input="validateTime"
      />
      <span>:</span>
      <input
        class="minutes"
        type="number"
        min="0"
        max="59"
        maxlength="2"
        v-model="minutes"
        ref="minutes"
        @focus="$event.target.select()"
        @input="validateTime"
      />
    </div>
    <div class="week-days-container">
      <div class="week-day-container" v-for="day in weekDays" :key="day.number">
        <span>{{ day.name }}</span>
        <input type="checkbox" v-model="day.enabled" @change="weekDayChanged(day)" />
      </div>
    </div>
    <div class="month-days-container">
      <MonthDaysSelector :highlighted="enabledMonthDays" @highlighedChanged="monthDayChanged" />
    </div>
  </div>
</template>
<script>
import ToggleButton from "@/components/general/ToggleButton.vue";
import MonthDaysSelector from "@/components/general/MonthDaysSelector.vue";

export default {
  props: ["alarm"],
  components: { ToggleButton, MonthDaysSelector },
  computed: {
    zone: {
      get: function() {
        return this.alarm.zone;
      },
      set: function(value) {
        this.alarm.zone = value;
      }
    },
    minutes: {
      get: function() {
        let minutes = this.alarm.time % 60;
        if (minutes < 10) {
          return "0" + minutes.toString();
        }
        return minutes;
      },
      set: function(value) {
        this.setTime(this.hours, value);
      }
    },
    hours: {
      get: function() {
        const h = Math.trunc(this.alarm.time / 60);
        if (h < 10) {
          return "0" + h.toString();
        }
        return h;
      },
      set: function(value) {
        this.setTime(value, this.minutes);
      }
    }
  },
  data() {
    return {
      weekDays: [
        {
          number: 0,
          name: "Пн",
          enabled: false
        },
        {
          number: 1,
          name: "Вт",
          enabled: false
        },
        {
          number: 2,
          name: "Ср",
          enabled: false
        },
        {
          number: 3,
          name: "Чт",
          enabled: false
        },
        {
          number: 4,
          name: "Пт",
          enabled: false
        },
        {
          number: 5,
          name: "Сб",
          enabled: false
        },
        {
          number: 6,
          name: "Вс",
          enabled: false
        }
      ],
      enabledMonthDays: [],
      monthDays: Array(31)
        .fill(0)
        .map((e, i) => {
          return { number: i, enabled: false };
        }),
      timezones: Array(25)
        .fill(-12)
        .map((e, i) => e + i)
    };
  },
  methods: {
    monthDayChanged(payload) {
      const { day, highlighted } = payload;
      if (highlighted) {
        this.alarm.month_days = this.alarm.month_days | Math.pow(2, day);
      } else {
        this.alarm.month_days = this.alarm.month_days & ~Math.pow(2, day);
      }
    },
    weekDayChanged(day) {
      if (day.enabled) {
        this.alarm.days = this.alarm.days | Math.pow(2, day.number);
      } else {
        this.alarm.days = this.alarm.days & ~Math.pow(2, day.number);
      }
    },
    setTime(h, m) {
      h = parseInt(h);
      m = parseInt(m);

      if (!h) h = 0;
      if (!m) m = 0;

      if (h > 23) h = 23;
      else if (h < 0) h = 0;

      if (m > 59) m = 59;
      else if (m < 0) m = 0;

      this.alarm.time = h * 60 + m;
    },
    validateTime() {
      if (!this.alarm.time) this.alarm.time = 0;

      let h = Math.trunc(this.alarm.time / 60);
      let m = this.alarm.time % 60;

      this.setTime(h, m);

      this.$refs.hours.value = this.hours;
      this.$refs.minutes.value = this.minutes;
    },
    onChangeEventHandler(event) {
      this.alarm.enabled = event.value;
    },
    newAlarm() {}
  },
  watch: {
    alarm: {
      handler: function(newAlarm) {
        for (let day of this.weekDays) {
          day.enabled = newAlarm.days & Math.pow(2, day.number);
        }
        for (let monthDay of this.monthDays) {
          monthDay.enabled = newAlarm.month_days & Math.pow(2, monthDay.number);
        }
        this.enabledMonthDays = this.monthDays.filter(d => d.enabled).map(d => d.number);
      },
      immediate: true
    }
  }
};
</script>
<style lang="postcss">
.alarm-container {
  padding-bottom: 3px;
  .status-container {
    display: flex;
    flex-direction: row;

    input {
      flex-grow: 1;
    }
  }
  .time-container {
    select {
      height: 100%;
      margin-right: 3px;
    }
  }
  .week-days-container {
    .week-day-container {
      display: inline;
    }
  }
  .month-days-container {
  }
}
</style>
